import type {ThemeVariablesType} from '@yosmanyga/theme';
import {variables as baseVariables} from '@yosmanyga/rich-ui';

const variables: ThemeVariablesType = {
    ...baseVariables,
    palette: {
        ...baseVariables.palette,
        brand1: {
            '0': '#FFFFFF',
            '50': '#ffefef',
            '100': '#ffdcdc',
            '200': '#ffbfbf',
            '300': '#ff9292',
            '400': '#ff5454',
            '500': '#ff1f1f',
            '600': '#ff0000',
            '700': '#db0000',
            '800': '#aa0000', // Base
            '900': '#940808',
            '950': '#520000',
            '1000': '#000000',
        },
        neutral: {
            '0': '#FFFFFF',
            '50': '#f7f7f7',
            '100': '#ededed',
            '200': '#dfdfdf',
            '300': '#c8c8c8',
            '400': '#aaaaaa', // Base
            '500': '#999999',
            '600': '#888888',
            '700': '#7b7b7b',
            '800': '#676767',
            '900': '#545454',
            '950': '#363636',
            '1000': '#000000',
        }
    },
};

export {variables};